import detectIE from '../utils/detect-ie';
const isIE= detectIE();

export default {
  name: 'config',
  getReducer(){
    const initialData = {
      default:{},
      isIE:isIE
    }

    return (state = initialData, { type, payload }) => {
      return state;
    }
  },

  selectDefaultConfig: (state) => {
    return state.config.default;
  },
  selectDefaultIsIE: (state) => {
    return state.config.isIE;
  },
  selectBasemapList: (state) => {
    return state.config.default.basemaps.map((b) => {
      if(b.url.indexOf('{accessToken}') !== -1) b.url = b.url.replace(/{accessToken}/ig, b.accessToken || '');
      if(b.url.indexOf('{s}') !== -1) b.url = b.url.replace(/{s}/ig, b.accessToken || '{a-c}');
      return b;
    });
  },

  selectDefaultLayers: (state) => {
    return state.config.default.datasets;
  }
}